'use client';
import ImageWithFallback from '@/src/features/ui/image/image-with-fallback';
import { ResponseStoreFrontVehicleLoanDetail } from '@/src/interfaces/data-contracts';
import Heading from '@/src/features/ui/heading';
import fmt from '@/src/utils/helpers/number-format';
import { CurrencyTypeMissing } from '@/src/interfaces/missing-types';
import classNames from 'classnames';
import PieChart from '@/src/features/shared/pie-chart';

type Props = {
  item: ResponseStoreFrontVehicleLoanDetail;
  withRoundedContainer?: boolean;
};

export const PieChartWidget: React.FC<Props> = ({ item, withRoundedContainer }) => {
  const data = [
    {
      id: 1,
      name: 'Anapara',
      value: item.amount,
    },
    {
      id: 2,
      name: 'Toplam faiz',
      value: item.totalInterest,
    },
    {
      id: 3,
      name: 'Tahsis ücreti',
      value: item.expenseAmount,
    },
  ];

  return (
    <section className="flex flex-col gap-6 px-4 py-0 md:rounded-xl md:border md:border-neutral100 md:px-5 md:py-6">
      <div className="flex items-center justify-between">
        <figure className="relative inline-flex h-[66px] w-[120px] rounded-lg border p-4 md:h-[68px] md:w-[146px]">
          <ImageWithFallback
            src={item.bank?.logoPath}
            alt={item.bank?.name}
            {...(!withRoundedContainer ? { width: 122, height: 66 } : { width: 100, height: 59 })}
          />
        </figure>
        <div>
          <Heading tagType="p" cls="mb-2 font-semibold text-[#252525] md:text-base text-sm">
            {item.bank?.name}
          </Heading>
          <Heading tagType="p" cls="mb-2 text-neutral500 md:text-base text-sm">
            {item.name}
          </Heading>
        </div>
      </div>
      <div className="md:h-min-[228px] flex items-center gap-6 md:gap-[62px] md:px-[85px]">
        <div className="h-[178px] w-[178px] md:h-[220px] md:w-[220px]">
          <PieChart
            colors={['#4A49BB', '#F26722', '#262626']}
            data={[item.amount, item.totalInterest, item.expenseAmount]}
            fill
          />
        </div>
        <div className="flex flex-col gap-6 text-left">
          {data.map((item: any) => {
            return (
              <div className="flex flex-col gap-2" key={item.id}>
                <div className="text-base font-bold text-[#252525] md:text-xl">
                  {fmt(item.value, CurrencyTypeMissing.TRY)}
                </div>
                <div
                  className={classNames(
                    'whitespace-nowrap text-base text-neutral500 before:mr-1 before:inline-block before:h-[14px] before:w-[14px] before:rounded md:before:mr-2 md:before:mt-auto',
                    { 'before:bg-[#4A49BB]': item.id == 1 },
                    { 'before:bg-[#F26722]': item.id == 2 },
                    { 'before:bg-[#262626]': item.id !== 1 && item.id !== 2 }
                  )}
                >
                  {item.name}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
